// Content retained for the public landing page. Original documentation expectations are preserved in content-site/__fixtures__.

export const landingAnalyticsSnippet = `import { Bavimail } from 'bavimail'

const mail = new Bavimail({
  apiKey: process.env.BAVIMAIL_API_KEY!,
})

const summary = await mail.analytics.getDeliverabilitySummary({
  range: '7d',
})

const recent = await mail.analytics.getDeliverabilityRecent({
  limit: 10,
})`;

export const landingDomainSnippet = `import { Bavimail } from 'bavimail'

const mail = new Bavimail({
  apiKey: process.env.BAVIMAIL_API_KEY!,
})

const domain = await mail.domains.create({
  domain: 'yourdomain.com',
  inboundEnabled: false,
})

const setup = await mail.domains.getSetup(domain.id)
const dns = await mail.domains.getDnsStatus(domain.id)`;

export const landingSendSnippet = `import { Bavimail } from 'bavimail'

const mail = new Bavimail({
  apiKey: process.env.BAVIMAIL_API_KEY!,
})

await mail.emails.send({
  aliasId: 'your-alias-id',
  toEmail: 'hello@example.com',
  subject: 'Welcome aboard',
  body: '<h1>Hello from Bavimail</h1>',
})`;

export const landingWebhookSnippet = `import { verifyWebhookSignature } from 'bavimail'

app.post('/webhooks/email', async (req, res) => {
  const payload = JSON.stringify(req.body)
  const event = await verifyWebhookSignature(
    payload,
    req.headers['x-webhook-signature'],
    req.headers['x-webhook-timestamp'],
    process.env.BAVIMAIL_WEBHOOK_SECRET!,
  )

  if (event.eventType === 'email.outbound.delivered') {
    await reconcileEmailState(event)
  }

  res.status(200).end()
})`;

export const sdkAvailabilitySummary =
  "Official SDKs are available for TypeScript and Python. The HTTP API also works with any language that can make standard HTTPS requests.";
